import React, {useState} from 'react';
import {Modal, ModalBody} from "react-bootstrap";
import {LiaEdit} from "react-icons/lia";
import {MdDelete} from "react-icons/md";
import {updateTerm} from "../../services/TermRepository";

export function TermGridElement({term}) {

    const[edit, setEdit] = useState(false);
    const[editedData, setEditedData] = useState(term);

    function updateEntity(field, value) {

        const copy = {...editedData};
        copy[field] = value;
        setEditedData(copy);
    }

    return(

        <div>
            <Modal show={edit} centered={true}  onHide={() => setEdit(false)}>
                <Modal.Header closeButton >
                    <Modal.Title>
                        Rediger begrep
                    </Modal.Title>
                </Modal.Header>

                <ModalBody>
                    <div className={"d-flex flex-column"}>
                        <input className={"form-control mb-2"} type={"text"} value={editedData.term} placeholder={term.term ? term.term : "Begrep (ingen verdi)"} onChange={(e) => updateEntity("term", e.target.value)}/>
                        <textarea className={"form-control mb-2"} value={editedData.definition} placeholder={term.definition ? term.definition : "Definisjon (ingen verdi)"} onChange={(e) => updateEntity("definition", e.target.value)}/>
                        <button className={"btn btn-success"} onClick={() => updateTerm(editedData)}>Lagre</button>
                    </div>

                </ModalBody>

            </Modal>

            <div className={"border bg-light rounded p-3 mb-2"}>
                <div className={"row"}>
                    <div className={"col"}>
                        <h4>{term.term}</h4>
                    </div>
                    <div className={"col-1"}>
                        <button className={"btn btn-light border rounded"}>
                            <LiaEdit size={24} onClick={() => setEdit(true)}/>
                        </button>
                    </div>
                    <div className={"col-1"}>
                        <button className={"btn btn-danger text-white"}>
                            <MdDelete size={24}/>
                        </button>
                    </div>

                </div>

                <p>{term.definition}</p>
            </div>
        </div>

    );

}